import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import { Stepper, SubmitBar, PasswordInput, NumberKeyboard, Toast, Cell, CellGroup, Collapse, CollapseItem, RadioGroup, Radio, Divider, Card } from 'vant';
import ElementUI, { Message } from 'element-ui'
import clipboard from 'clipboard'
import vco from "v-click-outside"
import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import axios from 'axios'
import VueEllipseProgress from 'vue-ellipse-progress'
import mqtt from 'mqtt';
import { initWebSocket } from './websocket'
import PermissionPlugin from '@/plugins/permission'
import { permissionManager } from '@/utils/permission'

import "@/assets/scss/app.scss";

// import Vconsole from 'vconsole';
import 'element-ui/lib/theme-chalk/index.css'
import Utils from './utils'
const Base64 = require('js-base64').Base64
// new Vconsole();
Vue.prototype.$bus = new Vue();

Vue.prototype.$axios = axios;
Vue.prototype.clipboard = clipboard;
let domain = document.domain
if (process.env.NODE_ENV == "development") {
  domain = "adminv3.aicoiot.com"
}
Vue.prototype.apiuri = "https://" + domain + "/api.php";
Vue.prototype.wsuri = "wss://" + domain + ":1880/wsapi";
Vue.prototype.hostname = domain
Vue.prototype.mqtt = mqtt
// Vue.prototype.$cardreader = cardreader
Vue.prototype.cardtopic = "busiot/w00a1"
Vue.prototype.username = domain.split('.')[0]
Vue.config.productionTip = false
// Vue.prototype.version = process.env.version
Vue.prototype.version = process.env.VUE_APP_VERSION
Vue.prototype.deviceapi = "https://api.aicoiot.com/deviceapi.php"
Vue.prototype.aeskey = "PS3MDBxgD5z1mENRjaQSHndXMmzVijX3"
Vue.prototype.$utils = Utils;
Vue.prototype.Base64 = Base64;
Vue.prototype.serial = false;
Vue.prototype.websocket = false;
Vue.prototype.otp_enable = false;
Vue.prototype.$card_reader_port = new Vue({
  data: {
    value: ''
  }
})
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(Toast);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Divider);
Vue.use(Card);
Vue.use(Stepper);
Vue.use(SubmitBar);
Vue.use(VueEllipseProgress)
Vue.use(ElementUI)
Vue.use(PermissionPlugin)

Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.component('apexchart', VueApexCharts)

axios.interceptors.response.use(
  (response) => {
    if (response.data.status === 403) {
      localStorage.removeItem('user');
      Message({
        message: i18n.t('login.timeout'), // 提示信息
        type: 'warning',
        showClose: true,
        duration: 3000 // 持续时间为 3000 毫秒
      });
      router.push('/login'); // 跳转到登录页面
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status == 405) {
      Message({
        message: i18n.t('error.methodNotAllowed'), // 可以在i18n中配置对应的错误信息
        type: 'error',
        showClose: true,
        duration: 10000 // 持续时间为 3000 毫秒
      });
    }
    return Promise.reject(error);
  }
);

initWebSocket('ws://127.0.0.1:8765/', JSON.stringify({
  type: 'command',
  command: 'scan'
}));

const app = new Vue({
  router,
  store,
  i18n,
  data: function () {
    return {

      ismobile: false,
    }
  },
  render: h => h(App)
})

app.$mount('#app')

if (localStorage.getItem('user')) {
  permissionManager.ensureReady()
}